/**
 * GoNOW API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2020-12-7
 * Contact: info@zero-spec.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
* The IconSet model module.
* @module model/IconSet
* @version 2020-12-7
*/
export default class IconSet {
    /**
    * Constructs a new <code>IconSet</code>.
    * @alias module:model/IconSet
    * @class
    * @param normal {String} 
    */

    constructor(normal) {
        
        
        this['normal'] = normal;
        
    }

    /**
    * Constructs a <code>IconSet</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/IconSet} obj Optional instance to populate.
    * @return {module:model/IconSet} The populated <code>IconSet</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new IconSet();
                        
            
            if (data.hasOwnProperty('normal')) {
                obj['normal'] = ApiClient.convertToType(data['normal'], 'String');
            }
            if (data.hasOwnProperty('x2')) {
                obj['x2'] = ApiClient.convertToType(data['x2'], 'String');
            }
            if (data.hasOwnProperty('x4')) {
                obj['x4'] = ApiClient.convertToType(data['x4'], 'String');
            }
        }
        return obj;
    }

    /**
    * @member {String} normal
    */
    'normal' = undefined;
    /**
    * @member {String} x2
    */
    'x2' = undefined;
    /**
    * @member {String} x4
    */
    'x4' = undefined;




}
